export default __webpack_public_path__ + "static/media/ai_LEDActive.3d81d94f.svg";